import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLanguageContext } from "../context/LanguageContext";
import { useUpdateContext } from "../context/UpdateContext";
import NewsletterSignup from "../components/NewsletterSignup";
import Modal from "../components/Modal";
import updateLog from '../update-log.json';
import { FaSquareXTwitter, FaSquareFacebook } from "react-icons/fa6";

const Homepage: React.FC = () => {
    const { setDidUpdate } = useUpdateContext();
    const { isHE } = useLanguageContext();
    const [termsOpen, setTermsOpen] = useState(false);
    const currentUpdate = updateLog.lastUpdate;

    useEffect(() => {
        const manualDate = new Date(currentUpdate);
        const localStorageKey = currentUpdate;

        const storedDateString = localStorage.getItem(localStorageKey) || "2024-12-03"; // Default initial value
        const storedDate = new Date(storedDateString);
        if (manualDate > storedDate) {
            setDidUpdate(true);
            localStorage.setItem(localStorageKey, currentUpdate);
        }
    }, [currentUpdate, setDidUpdate]);

    return (
        <div className="min-h-screen flex flex-col justify-between bg-homepage p-2 overflow-x-hidden">
            <div
                className={
                    isHE ?
                        "flex flex-col-reverse justify-between md:flex-row" :
                        "flex flex-col justify-between md:flex-row"

                }>
                <div className="basis-1/3 md:basis-1/4 flex flex-col mt-0.5 ">
                    {!isHE ? (
                        <>
                            <h1
                                className="text-2xl mx-3"
                                style={{ color: "#F88158" }}
                            >Hoops Boarding Gate</h1>
                            <h2 className="text-lg mt-2">
                                <span
                                    className="mx-2"
                                    style={{ color: "#F88158" }}
                                >
                                    Destination:
                                </span>
                                <span>
                                    <span>
                                        &nbsp;
                                    </span>
                                    <span
                                        dir="ltr"
                                        className="inline-block bg-nba-gradient font-bold tracking-wider text-white px-3 py-1 rounded-lg ring-1 ring-white/25 shadow-elevation"
                                    >
                                        NBA
                                    </span>

                                </span>

                            </h2>
                            <div className="w-full mt-5 md:w-5/6">
                                <p className="mx-5 mb-3 text-justify text-white">
                                    Your gateway to prospect evaluations from all over the NBA Draft comuunity, along with accumulated data on past evaluations of Draft Analysts!
                                </p>
                            </div>
                        </>
                    ) : (
                        <div dir="rtl">
                            <h3
                                className="text-xl font-semibold mt-3"
                                style={{ color: "#F88158" }}
                            >עדכונים אחרונים
                            </h3>
                            <ul className="text-white text-sm text-right mr-2 ml-3 mt-5">
                                <li className="mb-3" style={{ color: "#F88158" }}>
                                    <span className="font-bold">09.07.2026:</span>&nbsp;
                                    <Link to="/redrafts/jaylen-brown-2016-redraft" className="font-bold underline-offset-2 hover:underline">פרספקטיבת רי-דראפט בת 10 שנים על מחזור 2016</Link>
                                </li>
                                <li className="mb-3">
                                    <span className="font-bold">21.06.2026:</span>&nbsp;
                                    <Link to="/collective-mock-draft" className="font-bold underline-offset-2 hover:underline">המוק דראפט הקולקטיבי שלנו עלה לאוויר!</Link>
                                </li>
                                {updateLog.updates.slice(0, 3).map((update, index) => (
                                    <li key={index} className={index > 0 ? "mt-3" : ""}>
                                        <span className="font-bold">
                                            {update.date}:
                                        </span>&nbsp;
                                        {isHE ? update.he : update.en}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )
                    }
                </div>
                <div className="basis-1/3 md:basis-1/2 mx-2 rounded-2xl flex items-center justify-center">
                    <img
                        src="../assets/bg.png"
                        alt="terminal with hardwood floor & draft board"
                        className="object-scale-down md:w-full md:object-contain rounded-2xl shadow-elevation-lg ring-1 ring-white/10"
                    />
                </div>
                <div className="basis-1/3 md:basis-1/4 flex flex-col mt-0.5 font-sans" dir="rtl">
                    {isHE ? (
                        <>
                            <h1
                                className="text-2xl mx-3 font-bold"
                                style={{ color: "#F88158" }}
                            >הופס בורדינג גייט</h1>
                            <h2 className="text-lg mt-2">
                                <span style={{ color: "#F88158" }}>
                                    היעד:

                                </span>
                                <span>
                                    <span>&nbsp;</span>
                                    <span
                                        dir="ltr"
                                        className="inline-block bg-nba-gradient font-bold tracking-wider text-white px-3 py-1 rounded-lg ring-1 ring-white/25 shadow-elevation"
                                    >
                                        NBA
                                    </span>
                                </span>
                            </h2>
                            <div className="w-full mt-5 md:w-5/6">
                                <p
                                    className="mx-5 mb-3 text-right tracking-tight text-sm text-white"
                                >
                                    האתר היחיד בעברית למידע על פרוספקטים של דראפט ה-NBA ועוד!
                                </p>
                            </div>
                        </>
                    ) : (
                        <div dir="ltr">
                            <h3
                                className="text-xl font-semibold mt-3"
                                style={{ color: "#F88158" }}
                            >Last Updates
                            </h3>
                            <ul className="text-white text-sm text-left mr-2 ml-3 mt-5">
                                <li className="mb-3" style={{ color: "#F88158" }}>
                                    <span className="font-bold">09.07.2026:</span>&nbsp;
                                    <Link to="/redrafts/jaylen-brown-2016-redraft" className="font-bold underline-offset-2 hover:underline">A 10-year re-draft perspective on the 2016 class</Link>
                                </li>
                                <li className="mb-3">
                                    <span className="font-bold">21.06.2026:</span>&nbsp;
                                    <Link to="/collective-mock-draft" className="font-bold underline-offset-2 hover:underline">Our Collective Mock Draft is now live!</Link>
                                </li>
                                {updateLog.updates.slice(0, 3).map((update, index) => (
                                    <li key={index} className={index > 0 ? "mt-3" : ""}>
                                        <span className="font-bold">
                                            {update.date}:
                                        </span>&nbsp;
                                        {isHE ? update.he : update.en}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )
                    }
                </div>
            </div>
            <div className="flex justify-center my-4">
                <NewsletterSignup />
            </div>
            <footer
                className="text-xs border-t border-gray-700 pt-2 text-white"
            >
                <div className="text-xs mt-3 text-white">
                    <a
                        href="mailto:contact@hoops-bg.net"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        contact@hoops-bg.net
                    </a>
                </div>
                <div className="ms-3 mt-0.5 flex items-center gap-2">
                    <a
                        href="https://x.com/Hoops_BG"
                        target="_blank"
                        rel="noopener noreferrer"

                    >
                        <FaSquareXTwitter />
                    </a>
                    <a
                        href="https://www.facebook.com/people/Hoops-Boarding-Gate-%D7%94%D7%95%D7%A4%D7%A1-%D7%91%D7%95%D7%A8%D7%93%D7%99%D7%A0%D7%92-%D7%92%D7%99%D7%99%D7%98/61584076406945/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Facebook"
                    >
                        <FaSquareFacebook />
                    </a>
                </div>
                <div>
                    <button
                        type="button"
                        onClick={() => setTermsOpen(true)}
                        className="text-xs text-gray-300 underline-offset-2 hover:text-white hover:underline transition"
                    >
                        {isHE ? "תקנון ותנאי שימוש" : "Terms and Agreements"}
                    </button>
                </div>
            </footer>

            <Modal
                isOpen={termsOpen}
                onClose={() => setTermsOpen(false)}
                title={isHE ? "תקנון ותנאי שימוש" : "Terms and Agreements"}
                isHE={isHE}
            >
                <div className="space-y-4">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque euismod, nisi vel consectetur interdum, nisl nunc egestas nunc, vitae tincidunt nisl nunc euismod nunc. Sed euismod, nisi vel consectetur interdum, nisl nunc egestas nunc, vitae tincidunt nisl nunc euismod nunc.</p>
                    <p>Vivamus suscipit tortor eget felis porttitor volutpat. Curabitur aliquet quam id dui posuere blandit. Praesent sapien massa, convallis a pellentesque nec, egestas non nisi. Donec sollicitudin molestie malesuada. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula.</p>
                    <p>Nulla quis lorem ut libero malesuada feugiat. Proin eget tortor risus. Cras ultricies ligula sed magna dictum porta. Sed porttitor lectus nibh. Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a. Quisque velit nisi, pretium ut lacinia in, elementum id enim.</p>
                    <p>Donec rutrum congue leo eget malesuada. Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. Praesent sapien massa, convallis a pellentesque nec, egestas non nisi. Curabitur aliquet quam id dui posuere blandit. Nulla porttitor accumsan tincidunt. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus.</p>
                    <p>Pellentesque in ipsum id orci porta dapibus. Sed porttitor lectus nibh. Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. Donec sollicitudin molestie malesuada. Praesent sapien massa, convallis a pellentesque nec, egestas non nisi. Proin eget tortor risus. Cras ultricies ligula sed magna dictum porta.</p>
                    <p>Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque velit nisi, pretium ut lacinia in, elementum id enim. Sed porttitor lectus nibh. Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. Nulla porttitor accumsan tincidunt.</p>
                    <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. Proin eget tortor risus. Cras ultricies ligula sed magna dictum porta. Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus.</p>
                    <p>Sed porttitor lectus nibh. Curabitur aliquet quam id dui posuere blandit. Nulla quis lorem ut libero malesuada feugiat. Proin eget tortor risus. Donec rutrum congue leo eget malesuada. Pellentesque in ipsum id orci porta dapibus. Quisque velit nisi, pretium ut lacinia in, elementum id enim.</p>
                </div>
            </Modal>
        </div>
    )
}

export default Homepage;